import { Component, Fragment } from 'preact';
import Stream from './stream/root.jsx';

import { StreamContextStatusChannel } from './stream/context/status_channel.jsx';
import { StreamContextStreamId } from './stream/context/stream_id.jsx';

import { createConsumer } from "@rails/actioncable"

export default class StreamsList extends Component {
  state = { streams: [], streamsStatusChannel: null };

  // Messages arrive ~1/s as full snapshots. Rather than rendering synchronously
  // on every WebSocket message (which starves the event loop and makes the page
  // unresponsive when renders lag behind the message rate — e.g. after the tab
  // was backgrounded and a backlog flushes), we coalesce into a pending buffer
  // and flush at most once per animation frame with the latest state.
  _pendingReplace = null;
  _pendingUpdates = {};
  _rafId = null;

  _scheduleFlush() {
    if (this._rafId != null) return;
    this._rafId = requestAnimationFrame(() => {
      this._rafId = null;
      let streams = this._pendingReplace != null ? this._pendingReplace : this.state.streams;
      const updates = this._pendingUpdates;
      if (Object.keys(updates).length) {
        // Keep the existing object reference for unchanged streams so memo() can skip them.
        streams = streams.map(s => updates[s.id] || s);
      }
      this._pendingReplace = null;
      this._pendingUpdates = {};
      this.setState({ streams });
    });
  }

  componentDidMount() {
    var self = this;
    this.consumer = createConsumer();
    const ssc = this.consumer.subscriptions.create({ channel: 'StreamStatusChannel' }, {
      received(data) {
        if (data.op == 'replace') {
          // A replace defines the full set/order and supersedes any queued updates.
          self._pendingReplace = data.streams;
          self._pendingUpdates = {};
        } else if (data.op == 'update') {
          Object.assign(self._pendingUpdates, data.idx);
        } else {
          console.log(data);
          return;
        }
        self._scheduleFlush();
      }
    });
    this.setState({ streamsStatusChannel: ssc });
  }

  componentWillUnmount() {
    if (this._rafId != null) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }
    this.setState({ streamsStatusChannel: null });
    this.consumer.disconnect();
    this.consumer = null;
  }


  render({ filter }) {
    const listStreams = this.state.streams.filter(stream => stream.name.toLowerCase().includes(filter.toLowerCase())).
      map(stream =>
        <Fragment key={stream.id}>
          <StreamContextStreamId.Provider value={stream.id}>
            <Stream stream={stream} />
          </StreamContextStreamId.Provider>
        </Fragment>
      )
    return (
      <StreamContextStatusChannel.Provider value={this.state.streamsStatusChannel}>
        <Fragment>{listStreams}</Fragment>
      </StreamContextStatusChannel.Provider>
    );
  }
}
